'use strict';
require('./CompanyChecklistService.js');

CompanyChecklistCtrl.$inject = [
  '$scope',
  '$stateParams',
  'checklists'
];
function CompanyChecklistCtrl(
  $scope,
  $stateParams,
  checklists
) {
  $scope.checklists = checklists;
}

CompanyChecklistCtrl.resolve = {
  checklists: ['$stateParams', 'CompanyChecklistService', function($stateParams, CompanyChecklistService){
    return CompanyChecklistService.query({
      companyId: $stateParams.companyId,
      relativeID: $stateParams.companyId,
      limit: 1000
    });
  }]
};

module.exports = CompanyChecklistCtrl;

angular.module('dokiv')
  .controller('CompanyChecklistCtrl', CompanyChecklistCtrl);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/checklist/CompanyChecklistCtrl.js
// module id = 321
// module chunks = 0